import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import balanceIcon from '../assets/select-brand-balance-icon.png'
import { REWARDS_BALANCE_MIN_LINE } from '../lib/rewards-copy'
import { formatUsd } from '../lib/profileStepUtils'
import {
  selectBrandBalanceAmountSx,
  selectBrandBalanceCardSx,
  selectBrandBalanceIconSx,
  selectBrandBalanceMinSx,
} from '../styles/selectBrandStyles'

interface Props {
  readonly balanceUsd: number
  readonly testId?: string
}

export function SelectBrandBalanceCard({
  balanceUsd,
  testId = 'select-brand-balance-strip',
}: Readonly<Props>) {
  return (
    <Box sx={selectBrandBalanceCardSx} data-testid={testId}>
      <Box>
        <Typography sx={selectBrandBalanceAmountSx}>
          Available Balance {formatUsd(balanceUsd)}
        </Typography>
        {REWARDS_BALANCE_MIN_LINE ? (
          <Typography sx={selectBrandBalanceMinSx}>{REWARDS_BALANCE_MIN_LINE}</Typography>
        ) : null}
      </Box>
      <Box component="img" src={balanceIcon} alt="" sx={selectBrandBalanceIconSx} aria-hidden />
    </Box>
  )
}
